// Périmètre du compte authentifié.
//
// Les identifiants `proprietaire_id` et `agence_id` ne proviennent JAMAIS du
// navigateur : ils sont calculés côté serveur par des fonctions SECURITY DEFINER
// basées sur l'utilisateur authentifié (`current_proprietaire_id()` /
// `current_agence_id()`). Le frontend les lit pour renseigner correctement les
// lignes qu'il insère ; la RLS revalide de toute façon chaque écriture.

import { supabase } from "./supabase";

export interface ScopeIds {
  /** Propriétaire authentifié (espace Propriétaire), sinon `null`. */
  proprietaireId: string | null;
  /** Agence authentifiée (espace Agence), sinon `null`. */
  agenceId: string | null;
}

export const EMPTY_SCOPE_IDS: ScopeIds = { proprietaireId: null, agenceId: null };

/** Lit le périmètre réel du compte connecté (source serveur). */
export async function fetchScopeIds(): Promise<ScopeIds> {
  const [proprietaire, agence] = await Promise.all([
    supabase.rpc("current_proprietaire_id"),
    supabase.rpc("current_agence_id"),
  ]);
  return {
    proprietaireId: (proprietaire.data as string | null) ?? null,
    agenceId: (agence.data as string | null) ?? null,
  };
}